import {grey, red} from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const PRIMARY_GREEN = '#487c3c';
const PRIMARY_GREEN_DARK = '#365e2d';
const PRIMARY_GREEN_LIGHT = '#e6efe3';

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: PRIMARY_GREEN,
            dark: PRIMARY_GREEN_DARK,
            light: PRIMARY_GREEN_LIGHT,
        },
        secondary: {
            main: '#fff',
        },
        background: {
            default: grey[100]
        },
        error: {
            main: red.A400,
        },
    },
    components: {
        // MUI X DatePicker — day cells
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: PRIMARY_GREEN,
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: PRIMARY_GREEN_DARK,
                        },
                        '&:focus': {
                            backgroundColor: PRIMARY_GREEN,
                        },
                    },
                    '&:hover': {
                        backgroundColor: PRIMARY_GREEN_LIGHT,
                    },
                },
                today: {
                    borderColor: `${PRIMARY_GREEN} !important`,
                    color: PRIMARY_GREEN,
                    fontWeight: 600,
                },
            },
        },
        // MUI X DatePicker — year selector
        PrivatePickersYear: {
            styleOverrides: {
                root: {
                    '& .Mui-selected': {
                        backgroundColor: `${PRIMARY_GREEN} !important`,
                        color: '#fff',
                    },
                },
            },
        },
        // MUI X DatePicker — month selector
        PrivatePickersMonth: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: `${PRIMARY_GREEN} !important`,
                        color: '#fff',
                    },
                },
            },
        },
        // Navigation arrows in calendar header
        MuiPickersArrowSwitcher: {
            styleOverrides: {
                button: {
                    color: PRIMARY_GREEN,
                },
            },
        },
        // Calendar header label (month + year)
        MuiPickersCalendarHeader: {
            styleOverrides: {
                switchViewButton: {
                    color: PRIMARY_GREEN,
                },
            },
        },
    },
});

export default theme;